
import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";

export const GET_TCL = gql`
  query MyQuery {
    homePage {
      lifestyleTitle
      lifestyle {
        contentItems {
          ... on LifestyleComponent {
            icon {
              urls
            }
            title
            text
            enabled
          }
        }
      }
    }
  }
`;

export async function fetchLifestyle() {
  const result = await apolloClient.query({
    query: GET_TCL,
    fetchPolicy: "network-only",
  });

  return result.data;
}
